export default "__VITE_ASSET__BhyQ7vqN__"